'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var map = {
  Dž: 'Џ',
  Lj: 'Љ',
  Nj: 'Њ',
  dž: 'џ',
  lj: 'љ',
  nj: 'њ',
  a: 'а',
  b: 'б',
  c: 'ц',
  č: 'ч',
  ć: 'ћ',
  d: 'д',
  đ: 'ђ',
  e: 'е',
  f: 'ф',
  g: 'г',
  h: 'х',
  i: 'и',
  j: 'ј',
  k: 'к',
  l: 'л',
  m: 'м',
  n: 'н',
  o: 'о',
  p: 'п',
  r: 'р',
  s: 'с',
  š: 'ш',
  t: 'т',
  u: 'у',
  v: 'в',
  z: 'з',
  ž: 'ж'
};
exports.default = map;
module.exports = exports['default'];